import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Routes } from '@angular/router';
import { pageNotFoundGuard } from './core/guards/page-not-found.guard';
import { environment } from 'environments/environment';
import { firstValueFrom, tap } from 'rxjs';
import { routeAliasTypes } from './app.routes.alias';
import { RouteType } from './core/models/route-type.enum';
import { RouterContainer } from './core/models/router-container.model';
import { ShebaLayoutComponent } from './pages/layout/sheba-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: ShebaLayoutComponent,
    children: []
  },
  {
    path: 'page-not-found',
    loadComponent: () =>
      import('./core/components/page-not-found/page-not-found.component').then((x) => x.PageNotFoundComponent)
  },
  {
    path: 'lobby',
    loadComponent: () =>
      import('./pages/t8-lobby-page/t8-lobby-page.component').then((x) => x.ShebaT8LobbyPageComponent)
  },
  {
    path: '**',
    canActivate: [pageNotFoundGuard],
    loadComponent: () =>
      import('./core/components/page-not-found/page-not-found.component').then((x) => x.PageNotFoundComponent)
  }
];

const containerTypePath: string = `${environment.clientUrl}/assets/container-type.json?v=${Math.floor(Date.now() / 60000) * 60000}`;

function getRouteUrl(path: string, languages: RouterContainer[]): string {
  if (path.startsWith('/')) {
    return getRouteUrl(path.substring(1), languages);
  }
  const language = languages.find((l) => path.startsWith(l.ContainerName.toLowerCase() + '/'));
  if (language) {
    path = path.replace(language.ContainerName.toLowerCase() + '/', '');
  }
  if (path.endsWith('/')) {
    return path.substring(0, path.length - 1);
  }
  return path;
}

export let languages: RouterContainer[] = [];
export let containerTypes: RouterContainer[] = [];

// ! WTF is going on here?
export function initializeAppRouter(http: HttpClient): () => Promise<any> {
  const addRouteChild = (path: string, routerAlias: any, routeChildren: any[]) => {
    const routerAliasObj = { ...routerAlias, path };
    delete routerAliasObj.alias;
    routeChildren.push(routerAliasObj);
  };

  return (): Promise<any> => {
    const headers = new HttpHeaders();
    return firstValueFrom(
      http.get<RouterContainer[]>(containerTypePath, { headers }).pipe(
        tap((dataRoutes) => {
          containerTypes = dataRoutes;
          dataRoutes.push({ ContainerUrl: '', ContainerAlias: 'homePage' } as RouterContainer);
          const routeChildren: any[] = [];
          languages = dataRoutes.filter((r) => r.ContainerAlias === 'lang');
          dataRoutes.forEach((route) => {
            // debugger
            const routeAlias = routeAliasTypes.find((ra) => ra.alias === route.ContainerAlias);
            if (routeAlias && route.ContainerUrl != null) {
              const containerUrl = getRouteUrl(route.ContainerUrl, languages);
              const path =
                routeAlias.type === RouteType.Container
                  ? `${containerUrl}${containerUrl.endsWith('/') ? '' : '/'}:pageName`
                  : containerUrl;
              addRouteChild(path, routeAlias, routeChildren);
            }
          });
          const routesLanguage = routes.find((r) => r.path === '');
          languages.forEach((lang) => {
            const routeLanguage = { ...routesLanguage, path: lang.ContainerName.toLowerCase() };
            routes.unshift(routeLanguage);
          });
          routes
            .filter((r) => r.path === '' || languages.some((l) => r.path === l.ContainerName.toLowerCase()))
            .forEach((r) => (r.children = r.children?.concat(routeChildren)));
        })
      )
    );
  };
}
